__turbopack_context__.v({
  "action": "Button-module__cIG3xa__action",
  "button": "Button-module__cIG3xa__button",
  "fullWidth": "Button-module__cIG3xa__fullWidth",
  "huge": "Button-module__cIG3xa__huge",
  "icon": "Button-module__cIG3xa__icon",
  "isFullRadius": "Button-module__cIG3xa__isFullRadius",
  "link": "Button-module__cIG3xa__link",
  "medium": "Button-module__cIG3xa__medium",
  "normal": "Button-module__cIG3xa__normal",
  "onlyIcon": "Button-module__cIG3xa__onlyIcon",
  "primary": "Button-module__cIG3xa__primary",
  "puffy": "Button-module__cIG3xa__puffy",
  "quiet": "Button-module__cIG3xa__quiet",
  "secondary": "Button-module__cIG3xa__secondary",
  "small": "Button-module__cIG3xa__small",
  "tertiary": "Button-module__cIG3xa__tertiary",
  "tiny": "Button-module__cIG3xa__tiny",
  "withIcon": "Button-module__cIG3xa__withIcon",
});
